import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
const NoRating = () => {
    const $ = _c(4);
    const translate = useTranslate();
    let t0;
    if ($[0] !== translate) {
        t0 = translate("messages.new");
        $[0] = translate;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    const text = t0;
    let t1;
    if ($[2] !== text) {
        t1 = <span className="text-xs text-rating font-bold uppercase leading-loose">{text}</span>;
        $[2] = text;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    return t1;
};
export default NoRating;
